import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingStatus } from '@app/core/state/types';
import { ButtonProps, IconAnimation, IconName } from '@bl/components';
import { BehaviorSubject, combineLatest, merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';

@Component({
  selector: 'app-table-refresh-button',
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <bl-frontend-button
        variant="tonal"
        [trailingIcon]="iconProps$ | async"
        [disabled]="disabled$ | async"
        (onclick)="onRefresh()"
        [title]="t('updateList')"></bl-frontend-button>
    </ng-container>
  `,
  providers: [getTranslationProvider('TableRefreshButtonComponent')],
})
export class TableRefreshButtonComponent extends TranslatableComponent {
  @Input() set loading(value: boolean) {
    this.internalLoadingBS.next(value ? LoadingStatus.Loading : LoadingStatus.NotStarted);
  }
  @Input() set disabled(value: boolean) {
    this.internalDisabledBS.next(value);
  }

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter<void>();

  public iconProps$: Observable<ButtonProps['trailingIcon']>;
  public disabled$: Observable<boolean>;

  private animate$: Observable<IconAnimation>;
  private internalLoadingBS = new BehaviorSubject<LoadingStatus>(LoadingStatus.NotStarted);
  private internalDisabledBS = new BehaviorSubject<boolean>(false);

  constructor() {
    super();

    this.animate$ = this.internalLoadingBS.pipe(map((status) => (status === LoadingStatus.Loading ? 'spin' : 'none')));

    this.iconProps$ = combineLatest([of({ name: 'sync' as IconName }), this.animate$]).pipe(
      map(([icon, animation]) => ({
        ...icon,
        size: 'lg',
        animation,
      })),
    );

    this.disabled$ = merge(this.internalDisabledBS, this.animate$.pipe(map((state) => state === 'spin')));
  }

  public onRefresh() {
    this.onClick.emit();
  }
}
